import { Box, styled } from '@mui/material';
import React from 'react';

interface AutocompleteContainerProps {
  children: React.ReactNode;
}

const StyledAutocompleteContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

const StyledAutocompleteInnerContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  flexWrap: 'wrap',
  gap: '16px',
  flex: 1,
});

function AutocompleteContainer(props: AutocompleteContainerProps) {
  return (
    <StyledAutocompleteContainer>
      <StyledAutocompleteInnerContainer>{props.children}</StyledAutocompleteInnerContainer>
    </StyledAutocompleteContainer>
  );
}

export default AutocompleteContainer;
